import { render, staticRenderFns } from "./addressView.vue?vue&type=template&id=418ca7c8&scoped=true&"
import script from "./addressView.vue?vue&type=script&lang=js&"
export * from "./addressView.vue?vue&type=script&lang=js&"
import style0 from "./addressView.vue?vue&type=style&index=0&id=418ca7c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418ca7c8",
  null
  
)

export default component.exports